import React, { useState } from "react";
import NameIcon from "../../../../svgs/inventory-type-name.svg";
import BrandIcon from "../../../../svgs/brand-name.svg";
import ModelIcon from "../../../../svgs/model-name.svg";
import TypeIcon from "../../../../svgs/type.svg";
import InventoryUploadField from "../../../Common/InventoryUploadField";
import FormField from "../../../../../Shared/Form/FormField";

const INVENTORY_TYPE_OPTIONS = [
  {
    value: "",
    label: "Select an inventory type Device/Sim/Other...",
    isPlaceholder: true,
  },
  { value: "device", label: "Device" },
  { value: "sim", label: "Sim" },
  { value: "other", label: "Other" },
];

const InventoryDetailsModal = ({ show, onClose, inventory, onDeactivate }) => {
  const [isDeactivating, setIsDeactivating] = useState(false);

  if (!show || !inventory) return null;

  const handleDeactivate = async () => {
    setIsDeactivating(true);
    try {
      await onDeactivate(inventory.id);
      onClose();
    } catch (error) {
      console.error("Error deactivating inventory:", error);
    } finally {
      setIsDeactivating(false);
    }
  };

  return (
    <div className="inventory-modal-overlay" onClick={onClose}>
      <form
        className="inventory-modal device-create-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="inventory-modal-header">
          <h3>Inventory Details</h3>
          <button className="close-btn" type="button" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="inventory-modal-body">
          <div className="attachment-upload-row">
            {[0, 1, 2].map((idx) => (
              <InventoryUploadField
                key={idx}
                idx={idx}
                uploadedImage={
                  inventory.images && inventory.images[idx]
                    ? inventory.images[idx]
                    : null
                }
                handleImageChange={() => {}}
                disabled={true}
              />
            ))}
          </div>
          <FormField
            id="inventory-name"
            name="name"
            type="text"
            title="Inventory Type Name"
            icon={NameIcon}
            value={inventory.name || ""}
            placeholder="Input inventory name..."
            readOnly={true}
          />
          <FormField
            id="brand-name"
            name="brandName"
            type="text"
            title="Brand Name"
            icon={BrandIcon}
            value={inventory.brand || ""}
            placeholder="Input brand name..."
            readOnly={true}
          />
          <FormField
            id="model-name"
            name="modelName"
            type="text"
            title="Model Name"
            icon={ModelIcon}
            value={inventory.model || ""}
            placeholder="Input model name..."
            readOnly={true}
          />
          <FormField
            id="inventory-type"
            name="type"
            type="text"
            title="Inventory Type"
            icon={TypeIcon}
            value={
              INVENTORY_TYPE_OPTIONS.find((opt) => opt.value === inventory.type)
                ?.label ||
              inventory.type ||
              ""
            }
            placeholder="Select inventory type..."
            readOnly={true}
          />
          <FormField
            id="inventory-description"
            name="description"
            type="textarea"
            title="Description"
            value={inventory.description || ""}
            placeholder="Inventory description..."
            readOnly={true}
          />
        </div>
        <div className="inventory-modal-footer">
          <button
            className="cancel-btn"
            type="button"
            onClick={onClose}
            disabled={isDeactivating}
          >
            Close
          </button>
          {inventory.is_active && (
            <button
              className="submit-btn"
              type="button"
              onClick={handleDeactivate}
              disabled={isDeactivating}
            >
              {isDeactivating ? (
                <>
                  <div className="upload-loader-small"></div>
                  Deactivating...
                </>
              ) : (
                "Deactivate"
              )}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default InventoryDetailsModal;
